











































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Toast } from "vant";

const reportSalesModule = namespace("reportSales");

@Component({
  components: {}
})
export default class List extends Vue {
	@reportSalesModule.State("saleRecordList") list!: any;
	couponCancelPageLoading!: boolean;

	pageNum: number = 1;
	pageSize: number = 100;

	loading: boolean = false;
	finished: boolean = true;

	activeStatus: string = '10';


	get loadingShow() {
		return this.loading;
	}
	set loadingShow(newVal) {
		this.loading = this.couponCancelPageLoading;
	}
	get couponList() {
		return this.list;
	}
	set couponList(newVal) {}

	mounted() {
		this.getData();
	}
	handleActiveChange() {
		this.pageNum = 1;
		this.getData();
	}

	handleCreateClick () {
		this.$router.push('/reportSales/form');
	}
	async getData() {
		const { success } = await this.$store.dispatch(
			"reportSales/getSaleRecordList",
			{
				auditStatus: this.activeStatus,
				pageNum: 1,
				pageSize: 100
			}
		);
		if (success) {
			if (success.data.pages == success.data.pageNum) {
				this.finished = true;
			}
			this.loading = false;
		}
	}

	onLoadList() {
		this.pageNum++;
		this.getData();
	}
	handleDetailsClick(item: any) {
		console.log(item);
		this.$router.push({path: '/reportSales/status', query: { id: item.id, active: this.activeStatus }});
	}
}
